import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from './header';
import TopNav from '../../../components/topNav';
import BottomFooter from './footer';
import Content from './content';
import Cooperation from './cooperation';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    componentDidMount() {}

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const headerData = {
            nav: content.nav,
            search: content.search,
            logo: content.logo,
            channelAd: content.channelAd,
            topAd: content.topAd
        };
        const contentData = {
            bottomAd: content.bottomAd,
            brandData: content.brandData,
            firstModuleData: content.firstModuleData,
            atlasModuleData: content.atlasModuleData,
        };

        const footerData = {
            footer: content.footer,
        };
        const cooperation = content.cooperation;

        return (
            <div className={styles.ip_col} id="module">
                <Header content={headerData} />
                <Chip id="260815" type="struct" title="汽车导航" groupName="导航栏" content={content.navigation}>
                    <TopNav />
                </Chip>
                <Content content={contentData} />
                <NoSSR>
                    <Chip
                        id="40117"
                        type="static"
                        title="底部合作链接"
                        groupName="底部合作链接"
                        position="relative"
                        content={cooperation}>
                        <Cooperation />
                    </Chip>
                </NoSSR>
                <BottomFooter content={footerData} />
                <div className={styles.bottom} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
